import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import TwoOption from './twoOption';
import MoreOption from './moreOption';

class SurveyContent extends React.PureComponent {
    static propTypes = {
        data: PropTypes.object,
        resultShow: PropTypes.bool,
        handleOptionSubmit: PropTypes.func,
        isSubmitSurvey: PropTypes.bool,
        isShowJoin: PropTypes.bool,
    };

    getSurveyContent = (data) => {
        const { resultShow, handleOptionSubmit, isSubmitSurvey, isShowJoin } = this.props;
        const {
            surveyinfo: { id, expire },
            result,
            count,
        } = data;

        if (
            result.length === 1 &&
            result[0].resultArray.choosetype === 'single' &&
            result[0].resultArray.option.length === 2
        ) {
            // 一个问题 单选 两个选项
            return (
                <TwoOption
                    surveyId={id}
                    votecount={count}
                    isExpire={expire === '0'}
                    resultShow={resultShow}
                    content={result[0].resultArray}
                    handleOptionSubmit={handleOptionSubmit}
                    isSubmitSurvey={isSubmitSurvey}
                />
            );
        }

        const content = result.map((item) => item.resultArray);

        // 其余
        return (
            <MoreOption
                surveyId={id}
                votecount={count}
                isExpire={expire === '0'}
                resultShow={resultShow}
                content={content}
                handleOptionSubmit={handleOptionSubmit}
                isSubmitSurvey={isSubmitSurvey}
                isShowJoin={isShowJoin}
            />
        );
    };

    render() {
        const { data } = this.props;

        return <div className={styles.survey_content}>{this.getSurveyContent(data)}</div>;
    }
}

export default SurveyContent;
